import { useProjectPriceQuery } from "shared/api/price/queries.generated"

import { useProjectState } from "entities/projects/model/useProjectState"

export function useProjectPrice({
  projectID,
  skip
}: {
  projectID: string
  skip?: boolean
}) {
  const { isPending } = useProjectState(projectID)
  const {
    data,
    loading: isLoading,
    error
  } = useProjectPriceQuery({
    variables: { id: projectID },
    skip: skip || isPending
  })

  const hasData = !!data?.projectPrice
  const isLoadingData = isLoading || (!error && !data?.projectPrice?.isValid)

  return {
    price: data?.projectPrice,
    isLoading: !hasData && isLoadingData,
    isUpdating: hasData && isLoadingData,
    error
  }
}
